export const ComingSoonCard = ({ label, aspect = "aspect-video", className = "", ...rest }) => (
  <div
    className={`relative grid place-items-center overflow-hidden border border-dashed border-white/15 bg-ink-2 ${aspect} ${className}`}
    {...rest}
  >
    <div className="absolute inset-0 opacity-[0.35] bg-[radial-gradient(circle_at_center,rgba(15,81,50,0.25),transparent_70%)]" />
    <p className="relative font-mono text-xs uppercase tracking-[0.35em] text-white/40 md:text-sm">{label}</p>
  </div>
);
